module.exports = __webpack_public_path__ + "static/media/311.265ed646.wav";